export default __webpack_public_path__ + "static/media/000_intro_part2.vp9.5b3d81ec.webm";